import { render, staticRenderFns } from "./suggest-result-simple.vue?vue&type=template&id=aa8da73e&"
import script from "./suggest-result-simple.vue?vue&type=script&lang=js&"
export * from "./suggest-result-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports